import React from 'react';
import AuthHeader from '../../components/ui/AuthHeader';
import HeroSection from './components/HeroSection';
import ProblemSection from './components/ProblemSection';
import SolutionSection from './components/SolutionSection';
import FeaturesSection from './components/FeaturesSection';
import HealthIndexPreview from './components/HealthIndexPreview';
import PricingSection from './components/PricingSection';
import Footer from './components/Footer';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-background">
      <AuthHeader isAuthenticated={false} />
      
      <main className="pt-16">
        <HeroSection />
        <ProblemSection />
        <SolutionSection />
        <FeaturesSection />
        <HealthIndexPreview />
        <PricingSection />
      </main>

      <Footer />
    </div>
  );
};

export default LandingPage;